import { post } from '@eika-infrastruktur/request';
import { FormValues } from '@/data/Types';

export const CONTEXT_PATH = '/forsikring-kontaktskjema-web';
export const SERVICE_PATH = '/rest/resource/email?partner=';

export const sendContactForm = async (data: FormValues, partner: string) =>
    post(`${CONTEXT_PATH}${SERVICE_PATH}${partner}`, data);
